import { render, staticRenderFns } from "./AgreeToTerms.vue?vue&type=template&id=b95759ac&"
import script from "./AgreeToTerms.vue?vue&type=script&lang=js&"
export * from "./AgreeToTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports